<template>
  <load-content :loading="isBusy" class="form-wrapper">

    <div v-if="error" class="error">{{error}}</div>

    <div v-if="relationship.create">
      <h4>{{$t("relations.associations.tag")}}</h4>
      <div class="form form--sidepanel">
        <div class="row">
          <div class="flex-2">
            <div class="form-group">
              <label for="">{{$t("relations.associations.category")}}</label>
              <input-select
                name="category_id"
                ref="category_id"
                :selectedValue="edit.category_id"
                :searchable="true"
                :options="categories.map(c => ({ value: c.id, label: c.name }))"
                :onChange="onChangeSelfCategory"
              />
            </div>
            <div class="form-group">
              <label for="">{{$t("relations.associations.tag")}}</label>
              <input-select
                name="tag_id"
                ref="tag_id"
                :selectedValue="edit.tag_id"
                :searchable="true"
                :options="selfTags.map(t => ({ value: t.id, label: t.name }))"
                :onChange="onChangeSelfTag"
                :onSearchChange="(searchText) => onSearchChange(searchText, edit.category_id, 1)"
                :loading="projectCategorySetupIsLoading && loadingElement == 1"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <h3>{{edit.tag_name}}</h3>
      <small><b>{{$t("relations.associations.category")}}:</b> {{edit.category_name}}</small>
    </div>
    <div class="form form--sidepanel">
      <div>
        <h4>{{$t("relations.associations.children")}}</h4>
        <div v-if="edit.child_tags.length > 0" class="child-tags">
          <div class="row" v-for="associated_tag in edit.child_tags" :key="associated_tag.temp_id">
            <div class="flex-2">
              <div class="form-group">
                <label for="">{{$t("relations.associations.category")}}</label>
                <input-select
                  name="parent_category_id"
                  ref="parent_category_id"
                  :selectedValue="associated_tag.category_id"
                  :options="categories.map(c => ({ value: c.id, label: c.name }))"
                  :onChange="(value) => onChangeChildCategory(associated_tag.temp_id, value)"
                />
              </div>
              <div class="form-group">
                <label for="">{{$t("relations.associations.tag")}}</label>
                <input-select
                  name="associated_tag_id"
                  ref="associated_tag_id"
                  :selectedValue="associated_tag.id"
                  :searchable="true"
                  :options="findTags(associated_tag.category_id, associated_tag.temp_id)"
                  :onChange="(value) => onChangeChildTag(associated_tag.temp_id, value)"
                  :onSearchChange="(searchText) => onSearchChange(searchText, associated_tag.category_id, associated_tag.temp_id)"
                  :loading="projectCategorySetupIsLoading && loadingElement == associated_tag.temp_id"
                />
              </div>
            </div>
            <span v-if="isEdit" class="remove" @click="() => onRemoveChild(associated_tag.temp_id)">
              <i class="fas fa-times"></i>
            </span>
          </div>
        </div>
        <div v-else class="empty-state">
          {{$t("relations.associations.empty")}}
        </div>
      </div>

      <div class="btn-container">
        <button v-if="!edit.create" class="btn btn-default btn-sm" @click="addChildTag">
          <i class="fas fa-plus"></i> {{$t("relations.actions.add")}}
        </button>
        <button class="btn btn-carma btn-sm" @click="saveChanges">
          <i class="fas fa-check"></i> {{$t("relations.actions.save")}}
        </button>
      </div>
    </div>
  </load-content>
</template>

<script>
import _ from 'lodash';
import { mapState, mapActions } from "vuex";

import FormHelper from '@/helpers/form';

import InputSelect from '@/components/form-components/input-select';
import LoadContent from '@/components/load-content';

export default {
  props: {
    relationshipType: String,
    relationship: Object,
    associations: Array,
    categories: Array,
    onSave: Function,
    isEdit: Boolean
  },

  data: function() {
    const edit = _.cloneDeep(this.relationship);
    return {
      error: '',
      edit,
      loadingElement: null,
      isBusy: false
    }
  },

  computed: {
    ...mapState({
      projectCategorySetupIsLoading: state => state.projectSetup?.projectCategorySetup?.isBusy,
      projectSetupGeneral: state => state?.projectSetup?.projectSetup?.data?.general,
      relationships: state => state.projectSetup?.relationships || {}
    }),
    selfTags: function() {
      let tags = [];
      const category = this.categories.find(c => c.id == this.edit.category_id);

      if (category) {
        const exists = this.associations?.map(t => t.tag_id) || [];
        tags = category.tags.filter(t => t != null && exists.includes(t.id) == false);

        if (this.edit.associated_tag_id)  {
          const inUse = this.associations?.filter(h => h.associated_tag_id == this.edit.associated_tag_id).map(h => h.tag_id);
          tags = tags.filter(t => t.id != this.edit.associated_tag_id && inUse.includes(t.id) == false);
        }
      }

      return tags;
    },
    parentTags: function() {
      let tags = [];
      const category = this.categories.find(c => c.id == this.edit.associated_tag_category_id);

      if (category) {
        tags = category.tags.filter(t => t != null && t.id != this.edit.tag_id);
      }

      return tags;
    },
    isUseOrgWithCategory() { return this.projectSetupGeneral?.organizations_with_category }
  },

  mounted() {
    if (this.edit.create) this.addChildTag();
  },

  methods: {
    ...mapActions({
      "getProjectCategoriesSetup": "projectSetup/getProjectCategoriesSetup"
    }),
    onChangeSelfCategory: function(value) {
      this.edit = {
        ...this.edit,
        category_id: value,
        tag_id: null
      }
    },

    onChangeSelfTag: function(value) {
      this.edit = {
        ...this.edit,
        tag_id: value
      }
    },

    onChangeParentCategory: function(value) {
      this.edit = {
        ...this.edit,
        associated_tag_category_id: value,
        associated_tag_id: null
      }
    },

    onChangeParentTag: function(value) {
      this.edit = {
        ...this.edit,
        associated_tag_id: value
      }
    },

    onChangeChildCategory: function(temp_id, value) {
      this.edit = {
        ...this.edit,
        child_tags: this.edit.child_tags.map(t => t.temp_id == temp_id ? { id: null, name: null, temp_id: t.temp_id, category_id: value } : t)
      }
    },

    onChangeChildTag: function(temp_id, value) {
      this.edit = {
        ...this.edit,
        child_tags: this.edit.child_tags.map(t => t.temp_id == temp_id ? { ...t, id: value } : t)
      }
    },

    findTags: function(category_id, temp_id) {
      let options = [];

      if (category_id != null) {
        const alreadyPicked = this.edit.child_tags.filter(t => t.temp_id != temp_id && t.category_id == category_id).map(t => t.id);
        const tags = this.categories.find(c => c.id == category_id).tags.filter(t => alreadyPicked.includes(t.id) == false && t.id != this.edit.tag_id && t.id != this.edit.associated_tag_id);
        // add already picked tag to options
        const pickedOption = this.edit.child_tags.filter(t => t.temp_id == temp_id && t.category_id == category_id).map(t => ({ id: t.id, name: t.name }));
        options = [...tags, ...pickedOption].map(t => ({ value: t.id, label: t.name }));
      }

      return _.uniqBy(options, 'value');
    },

    addChildTag: function() {
      const tag = { id: null, name: null, category_id: null, temp_id: this.generateTempId() };
      this.edit.child_tags.push(tag);
    },

    saveChanges: function () {
      const data =  {
          id: this.edit.tag_id ? this.edit.tag_id : this.edit.id,
          create: this.edit.create,
          category_id: this.edit.category_id,
          child_tags: this.edit.child_tags,
        }

      if (this.isValid(data)) {
        this.isBusy = true;
        this.onSave("association", data)
          .catch(error => {
            if (error.response?.data?.message === 'not_allowed_cardinality') {
              const categories = error.response.data.categories;
              const names = error.response.data.categories.map(c => `"${c.category_name}"`).join(', ');
              const errorMessage = this.$tc('relations.errors.not_allowed_cardinality', categories.length, [names]);
              this.error = errorMessage;
            }
          }).finally(() => {
            this.isBusy = false;
          });
      } else {
        this.errors = this.$t("relations.errors.different_tags");
      }
    },

    onRemoveChild: function(temp_id) {
      this.edit = {
        ...this.edit,
        child_tags: this.edit.child_tags.filter(t => t.temp_id != temp_id)
      }
    },

    isValid: function(relationship) {
      const validations = [relationship.id, relationship.category_id];
      for (let i = 0; i < relationship.child_tags.length; i++) {
        const tag = relationship.child_tags[i];
        validations.push(tag.id);
        validations.push(tag.category_id);
      }
      return _.every(validations);
    },

    generateTempId: function() {
      return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
        (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
      );
    },
    onSearchChange(searchText, categoryId, loadingElement) {
      FormHelper.delayFunction(this.onSearch(searchText, categoryId), 500, this, loadingElement);
    },
    onSearch (searchText, parentId) {
      this.globalTimeout = null;
      if(!parentId || !this.isUseOrgWithCategory) return;
      const filters = {tag_name: searchText, cat_id: parentId};
      this.fetchProjectCategories(filters)
    },

    fetchProjectCategories(filters) {
      const pagination = { page: 1, perPage: 20, order: 'name', sort: 'asc' };
      this.getProjectCategoriesSetup({ projectUid: this.$route.params.project_uid, pagination, filters})
    }
  },

  components: {
    InputSelect,
    LoadContent
  }
}
</script>

<style lang="scss" scoped>
  .form-wrapper {
    h3 {
      margin: 0 0 5px 0;
    }

    h4 {
      border-bottom: 2px solid #ddd;
      font-size: 14px;
      font-weight: 700;
      text-transform: uppercase;
      padding-bottom: 5px;
      padding-left: 10px;
      color: #b0b6b8;
      margin-top: 20px;
    }

    .row {
      display: flex;
      align-items: center;

      .flex-2 {
        display: flex;
        align-items: flex-start;
        flex: 1 1 auto;
        margin: 0 -10px;

        .form-group {
          flex: 0 0 50%;
          padding: 0 10px;
        }
      }
    }

    .child-tags {
      .remove {
        padding: 10px 10px;
        margin-left: 20px;
        cursor: pointer;
      }
    }

    .empty-state {
      margin-bottom: 20px;
    }

    .text {
      margin: 20px 0;
    }

    .btn {
      display: inline-block;
      width: auto;
    }
  }
</style>